export default __webpack_public_path__ + "static/media/no-items.c50662ac.svg";